import {postApi} from '../api'


export const forgetPasswordApi = (data)=> postApi(`/auth/forgetPassword`, data)
